import AuthInputPassword from "./AuthInputPassword"

export default AuthInputPassword
